import { gql } from '@apollo/client';

const updateLetterTemplate = gql`
  mutation updateLetterTemplate($input: LetterTemplateUpdate!, $id: Int!) {
    updateLetterTemplate(input: $input, id: $id) {
      id
      name
      description
      content
      variables_used
      created_at
      updated_at
    }
  }
`;

export default updateLetterTemplate;
